"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostgresSqlGenerator = void 0;
const base_1 = require("./base");
class PostgresSqlGenerator extends base_1.BaseSqlGenerator {
    quoteIdentifier(name) {
        return `"${name.replace(/"/g, '""')}"`;
    }
    generateModulo(left, right) {
        return `(${left} % ${right})`;
    }
}
exports.PostgresSqlGenerator = PostgresSqlGenerator;
//# sourceMappingURL=postgres.js.map